
function requestCheckActivateCard(requestOptionsExit)
{
    var request = fetch(`/api/hasActivatecard`, requestOptionsExit)
        .then(response => {       
             return (
                 response
                 ); 
            }
        );   
    return request;   
}
export const hasActivateCard ={
    requestCheckActivateCard
}